<template>
  <div>
    <nav aria-label="breadcrumb" id="breadcrumb">
      <ul class="breadcrumb new-submission">
        <li v-for="item in data" v-bind:key="item.id" class="breadcrumb-item">
          <a :href="item.href">{{item.name}}</a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  name: "Breadcrumb",
  props: {
    data: {
      type: Array,
      required: true
    }
  }
};
</script>

<style scoped>
#breadcrumb {
  background-color: #232937;
  padding: 20px 30px;
}
.new-submission {
  background-color: #232937 !important;
  margin: 0;
  padding: 0;
}
.breadcrumb-item a {
  color: #ed8652 !important;
}
.breadcrumb-item a:hover {
  text-decoration: none;
}
.breadcrumb-item:last-child a {
  color: #fff !important;
}
.breadcrumb-item + .breadcrumb-item::before {
  font-family: "fontAwesome";
  content: ">" !important;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/common/Breadcrumb.vue